if (!customElements.get('kronk-product-mobile-cta')) {
  customElements.define(
    'kronk-product-mobile-cta',
    class KronkProductMobileCta extends HTMLElement {
      connectedCallback() {
        this.nativeSubmit = document.getElementById(this.dataset.nativeSubmitId);
        if (!this.nativeSubmit) return;

        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.onMediaChange = this.onMediaChange.bind(this);
        this.onIntersect = this.onIntersect.bind(this);

        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.onMediaChange();
      }

      disconnectedCallback() {
        this.disconnectObserver();
        if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onMediaChange);
      }

      onMediaChange() {
        if (this.mediaQuery.matches) {
          this.connectObserver();
        } else {
          this.disconnectObserver();
          this.classList.remove('is-native-visible');
        }
      }

      connectObserver() {
        if (this.observer) return;

        this.observer = new IntersectionObserver(this.onIntersect, {
          rootMargin: '0px 0px -18% 0px',
          threshold: [0, 0.2, 0.6],
        });
        this.observer.observe(this.nativeSubmit);
      }

      disconnectObserver() {
        if (!this.observer) return;

        this.observer.disconnect();
        this.observer = null;
      }

      onIntersect(entries) {
        const entry = entries[0];
        this.classList.toggle('is-native-visible', entry.isIntersecting && entry.intersectionRatio > 0.2);
      }
    }
  );
}
